import React from 'react';
import { Trophy } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { currentSponsors, partnershipBenefits } from './data';

const PartnersAndBenefits = ({ onScrollToForm }) => (
  <section className="current-sponsors" data-testid="sponsors-partners-section">
    <div className="container">
      <h2 className="section-title">Our Partners & Sponsors</h2>
      <p className="section-subtitle">
        Thank you to our amazing community partners who make our mission possible
      </p>

      <div className="partners-grid">
        {currentSponsors.map((sponsor) => {
          const IconComponent = sponsor.icon;
          return (
            <Card
              key={sponsor.id}
              className="partner-card"
              data-testid={`partner-${sponsor.id}`}
            >
              <CardContent>
                <div className="partner-icon" style={{ backgroundColor: sponsor.color }}>
                  <IconComponent size={28} color="#fff" />
                </div>
                <div className="partner-type">{sponsor.type}</div>
                <h3 className="partner-name">{sponsor.name}</h3>
                <p className="partner-description">{sponsor.description}</p>
                {sponsor.website && (
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="partner-link"
                  >
                    Visit Website →
                  </a>
                )}
              </CardContent>
            </Card>
          );
        })}
      </div>

      <div className="partnership-benefits">
        <h3 className="benefits-title">Why Partner With the Panthers?</h3>
        <div className="benefits-grid">
          {partnershipBenefits.map((benefit) => {
            const IconComponent = benefit.icon;
            return (
              <div key={benefit.title} className="benefit-item">
                <div className="benefit-icon">
                  <IconComponent size={24} />
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="sponsor-cta-box">
        <Trophy size={40} />
        <h3>Your Business Could Be Featured Here!</h3>
        <p>
          Join our growing family of sponsors and make a lasting impact on youth athletics
          in Randallstown.
        </p>
        <Button className="btn-primary" onClick={onScrollToForm}>
          Become a Sponsor Today
        </Button>
      </div>
    </div>
  </section>
);

export default PartnersAndBenefits;
